export default function Title({title}:{title:string}){
    return(
        <h1 className='text-5xl font-bold text-white text-center'>
            {title}
        </h1>
    )
}